<template>
  <b-container>
    <b-form
      class="mt-5"
      @submit.prevent="onSubmit"
    >
      <b-row class="justify-content-center">
        <b-col
          cols="12"
          sm="6"
        >
          <b-form-group
            label="メールアドレス"
            label-for="email"
          >
            <b-form-input
              id="email"
              v-model="form.identifier"
              type="email"
              required
              placeholder="メールアドレスを入力してください"
            />
          </b-form-group>
        </b-col>
      </b-row>
      <b-row class="justify-content-center">
        <b-col
          cols="12"
          sm="6"
        >
          <b-form-group
            label="パスワード"
            label-for="password"
          >
            <b-form-input
              id="password"
              v-model="form.password"
              type="password"
              required
              placeholder="パスワードを入力してください"
              minlength="6"
            />
          </b-form-group>
        </b-col>
      </b-row>
      <b-row class="justify-content-center">
        <b-col
          cols="12"
          sm="6"
        >
          <b-form-group>
            <b-button
              type="submit"
              block
              variant="primary"
            >
              <b-icon
                v-if="authStatus === 'loading'"
                icon="three-dots"
                animation="cylon"
                font-scale="1"
              />
              <span v-else>
                ログイン
              </span>
            </b-button>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row class="justify-content-center">
        <b-col
          cols="12"
          sm="6"
        >
          <b-form-group>
            <div class="separator">
              <div class="line" />
              <span class="ml-2 mr-2">他のアカウントでログイン</span>
              <div class="line" />
            </div>
          </b-form-group>
        </b-col>
      </b-row>
      <template v-if="snsLoginEnabled">
        <ConnectButton
          :url="twitterConnectUrl"
          name="twitter"
          button-txt="Twitter アカウントでログイン"
        />
        <ConnectButton
          :url="facebookConnectUrl"
          name="facebook"
          button-txt="Facebook アカウントでログイン"
        />
        <ConnectButton
          :url="googleConnectUrl"
          name="google"
          button-txt="Google アカウントでログイン"
        />
      </template>
      <b-row class="justify-content-center">
        <b-col
          cols="12"
          sm="6"
          class="text-center"
        >
          <p>
            <b-link :to="{ name: 'signup' }">
              アカウントをお持ちでない方
            </b-link>
          </p>
          <p>
            <b-link :to="{ name: 'forgot-password' }">
              パスワードをお忘れの方
            </b-link>
          </p>
        </b-col>
      </b-row>
    </b-form>
  </b-container>
</template>

<script>
import {AUTH_REQUEST} from "@/store/constant";
import { mapGetters } from "vuex";
import { API_URL } from '@/store/constant';
import ConnectButton from '@/components/Account/ConnectButton'

export default {
  name: 'Login',
  components: {
    ConnectButton
  },
  data() {
    return {
      form: {
        identifier: '',
        password: '',
      },
      twitterConnectUrl: `${API_URL}/connect/twitter`,
      facebookConnectUrl: `${API_URL}/connect/facebook`,
      googleConnectUrl: `${API_URL}/connect/google`,
    }
  },
  computed: {
    ...mapGetters(['authStatus', 'features']),
    snsLoginEnabled() {
      if (!this.features) return null;
      return this.features.find(f => f.title === 'snslogin').enabled;
    },
  },
  methods: {
    onSubmit() {
      const { identifier, password } = this.form;
      this.$store.dispatch(AUTH_REQUEST, { identifier, password })
        .then(() => {
          this.$router.push({ name: 'events' });
        })
    },
  }
}
</script>

<style scoped>
.separator {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.line {
  flex: 2;
  background: #878686;
  height: 1px;
}
</style>
